import { createContext } from 'react';
import { MyOrder, SearchRequest } from 'ts/shared/interfaces/MOResponse';

export const MoContext = createContext({
  searchModel: undefined as SearchRequest | undefined,
  setSearchModel: (_searchModel: SearchRequest) => {},
  modelOptions: undefined as SearchRequest | undefined,
  setModelOptions: (_modelOptions: SearchRequest) => {},
  sort: {
    field: '',
    direction: '',
  },
  setSort: (_sort: { field: string; direction: string }) => {},
  visibleRows: [] as number[],
  setVisibleRows: (_rows: number[]) => {},
  mainFilter: '',
  setMainFilter: (_mainFilter: string) => {},
  activeOrder: undefined as MyOrder | undefined,
  setActiveOrder: (_order: MyOrder | undefined) => {},
});
